import { render, staticRenderFns } from "./ScoroProducts.vue?vue&type=template&id=fbda7e1c&"
import script from "./ScoroProducts.vue?vue&type=script&lang=js&"
export * from "./ScoroProducts.vue?vue&type=script&lang=js&"
import style0 from "./ScoroProducts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports